<app-disco-form [autoSave]=true  formKey="asset-attachments" [isEditMode]="true" [data]="data"
    (onSubmit)="onSubmit($event)"></app-disco-form>